import {BaseTerms} from "../../infrastructure/models/base-terms";

export class AppTerms extends BaseTerms {
  WEB_365SCORES = '365Scores';
  COUNTRY_IMAGE_TITLE = "COUNTRY_IMAGE_TITLE";
  REMOVE_SELECTION = "Remove from My Selections";
  ADD_SELECTION = "Remove from My Selections";
  SEE_MORE = "See More";
  POPULAR_COMPETITIONS = "Popular Competitions";
  POPULAR_COMPETITIONS_SPORTID_3 = "Popular Tournaments";
  WEB_POPULAR_TEAMS_SPORTID_3 = 'Popular Players';
  RED_CARD = "Red Card";
  TEAM_ADVANCED_STAR = "Team advanced to next stage";
  SEE_INJURIES_AND_SUSPENSIONS = "See Injuries & Suspensions";
  SEE_CONFIRMED_LINEUPS = "See Confirmed Lineups";
  WEB_TOOLTIP_SEE_LIVE_BOXSCORE = "See Confirmed box score";
  WATCH_LIVE_LANDING_PAGE_GAME = 'Watch the game now!';
  WATCH_LIVE_AVAILABLE = 'Live stream will be available for this match';
  GC_WATCH_GAME = "Watch the Game";
  STANDINGS = "Standings";
  SEE_ALL = "See All";
  SEE_LESS = "See less";
  MATCH_EVENT_GOAL = "Goal";
  MATCH_EVENT_YELLOW_CARD = "Yellow Card";
  MATCH_EVENT_SUB = "Substitution";
  MATCH_EVENT_PEN_SCORED = "Penalty scored";
  MATCH_EVENT_PEN_MISSED = "Missed penalty";
  MATCH_EVENT_RED_CARD = "Red Card";
  WEB_OWN_GOAL = "Own Goal";
  STATS = "Stats";
  WEB_SQUAD_TAB = "Squad";
  WEB_H2H_TITLE = "H2H";
  GAME_ODDS_BUTTON = "BET NOW";
  ODDS_COMPARISON_LIVE = "Live odds";
  ODDS_COMPARISON_PRE = "Pre-Game Odds";
  GC_ODDS_AMERICAN = "American";
  GC_ODDS_DECIMAL = "Decimal";
  GC_ODDS_FRACTIONAL = "Fractional";
  RECENT_SCORES = "Recent Matches";
  RESULTS_SCORES = "Results";
  FIXTURES_SCORES = "Fixtures";
  DATER_NEXT_DAY = "Next Day's Matches";
  DATER_PREV_DAY = "Previous Day's Matches";
  DATER_PREV_DAY_NOT_YESTERDAY = "Previous Day Matches";
  DATER_NEXT_DAY_NOT_TOMORROW = "Next Day Matches";
  DATER_CALENDAR = "Select another date";
  SEE_COMPETITION_TABLE = "See Table";
  COMPETITIONS = "Competitions";
  GAME_TITLE_VS = "v";
  LIVE = "Live";
  WEB_LIVE_TOGGLE = "LIVE";
  ALL_COMPETITIONS_A_TO_Z = 'All Competitions A-Z';
  MY_SELECTIONS = "My Selections";
  WEB_MY_SCORES_TITLE = "My Scores";
  WEB_BUZZ_BUTTON = "Buzz";
  WEB_FOOTER_BETBOLA_LINK = "Como Apostar";
  ALL_FOOTBALL_SCORES = "All Scores";
  WEB_MY_SCORES_SEE_ALL_MATCHES = "See all matches";
  WEB_MY_SELECTIONS_EMPTY_STATE_ALL = "Select Games, Teams and Competitions to follow them on My Scores";
  WEB_CHECK_IT_OUT_LATER = "Check it out later";
  GC_ALL = "All";
  WIDGET_POWERED_BY = "Powered By";
  WIDGETS_BACK = "Back";
  WIDGET_ODDS_BY_DEFAULT = 'Odds by';
  WEB_FIXTURES_BUTTON = "See All Fixtures";
  WEB_SCORES_FIXTURES_BUTTON_TOOLTIP = "See All Fixtures";
  WEB_RESULTS_BUTTON = "See All Results";
  WEB_RESULTS_BUTTON_TOOLTIP = "See All Results";
  WEB_MY_SCORES_UNDO_REMOVE_BUTTON = "Undo";
  WEB_MY_SCORES_UNDO_BUTTON_TOOLTIP = "Undo remove from My Scores";
  WEB_MY_SCORES_UNDO_REMOVE_TEXT = "Selection removed";
  WEB_PREDICTIONS_NEXT = "Next";
  WEB_PREDICTIONS_PREV = "Previous";
  WEB_PREDICTIONS_STATISTICAL_ANALY = "Statistical Analysis:";
  WEB_PREDICTIONS_WWW_TOTAL_VOTES = "Total Votes:";
  WEB_TOOLTIP_ODDS_ON = "Show Odds";
  WEB_TOOLTIP_ODDS_OFF = "Hide Odds";
  SETTINGS_ODDS = "Odds";
  WEB_ORIGINAL_ODDS = "Original Odds";
  WEB_TOOLTIP_ODDS_SETTINGS = "Odds settings";
  TENNIS_SCORE_ADVANTAGE = 'AD';
  WEB_MY_SCORES_TODAY_BUTTON = 'Today';
  WEB_MY_SCORES_TOMORROW = "Tomorrow";
  BETTING_OPP_WIDGET_TONIGHT = "Tonight"
  WEB_MY_SCORES_TEAMS_GAMES_SEPARATOR = "My teams & games";
  MOBILE_MENU_SCORES = "Scores";
  FIXTURES_GROUPS = 'Groups';
  GAME_TIME_TOMORROW = 'Tomorrow';
  WEB_GC_DAYS = "#NUM Days";
  WEB_PREDICTION_ODDS_BY = 'Odds by';
  WIDGET_SEE_ALL_SCORES_TEXT = "See all scores";
  WEB_WIDGET_BOOKMAKER_LINK_BOLAVIP = "https://sports.betway.com/pt/sports";
  WIDGET_SEE_ALL_SCORES_LINK = "https://resultados.bolavip.com/futbol/?c=ar";
  WEB_WIDGET_BOLAVIP_BOOKMAKER_ID = "9";
  WEB_MY_SCORES_WIZARD_BUTTON = 'Select Teams and Leagues';
  WEB_FIXTURES_EMPTY_STATE = 'No scheduled games available';
  WEB_RESULTS_EMPTY_STATE = 'No games results available';
  WEB_RECENT_EMPTY_STATE = 'No recent games available';
  WEB_DROPDOWN_FIXTURES = "Fixtures";
  WEB_DROPDOWN_RESULTS = "Results";
  WEB_DROPDOWN_SCORES_OVERVIEW = "Scores overview";
  WEB_WIZARD_ADD_MORE = "Add more";
  WEB_FOLLOWING_TITLE = "Following";
  WEB_GC_PREDICTIONS_TITLE = "Predictions";
  WEB_AGGREGATE_TEXT = "Aggregate";
  WEB_SHORT_AGGREGATE_TEXT = "Agg.";
  WEB_BOXSCORE = 'Box Score';
  WEB_FOLLOWING_EDIT_BUTTON = "Edit";
  WEB_GC_HEAD_TO_HEAD = "Head to Head";
  GROUP_TABLES = "Group Standings";
  COMMENTARY_NEWWEB = "Commentary";
  LINEUPS_GAME_MAIN = "Lineups";
  LINEUPS_MISSING = "Missing Players";
  INJURY_REPORT_GAME_MAIN = 'Injury Report'
  LINEUPS_DOUBTFUL = "Questionable";
  LINEUPS_WILL_NOT_PLAY = "Will not play";
  WEB_IMPORT_SELECTIONS_RELOAD_QR = "Reload QR code";
  WEB_IMPORT_SELECTIONS_LINK_IMPORT_FROM_APP = '{{import}} from app';
  WIDGETS_STANDINGS_POWERED_BY_TEMPLATE = "#COMPETITION Standings by {{ 365Scores }}"
  WEB_BRACKETS_IF_NEEDED = "If needed";
  WEB_BRACKETS_GAME_NUM = 'Game #NUM'
  WEB_BRACKETS = 'Brackets';
  WEB_DRAW_INSTEAD_OF_BRACKET = 'Draw';
  FOOTER_PRIVACY = "Privacy Policy";
  FOOTER_DELETE_ACCOUNT = "Delete Account";
  DIDOMI_WEB_AGREE_BUTTON_UNSUPPORTED_LANGS = 'Agree to close';
  DIDOMI_WEB_LEARN_MORE_BUTTON_UNSUPPORTED_LANGS = 'Learn more';
  DIDOMI_WEB_NOTICE_UNSUPPORTED_LANGS = 'With your agreement, we and our partners use cookies or similar technologies to store, access, and process personal data like your visit on this website. You can withdraw your consent or object to data processing based on legitimate interest at any time by clicking on "Learn More" or in our Privacy Policy on this website.'
  GDPR_WEB_INCLUDED_COUNTRIES = "1,2,3,4,5,6,7,8,9,11,12,13,16,19,20,21,22,23,24,25,29,30,33,37,38,39,40,41,42,46,92,93,100,102,166,323,329,337,338,339,346,352,-1";
  WEB_FOLLOW_BUTTON_FOLLOWING = 'Following';
  WEB_FOLLOW_BUTTON = 'Follow';
  WEB_COMPETITOR_HP_INPAGE_TITLE = "#COMPETITOR_NAME #LIVESCORE_MAIN_KEYWORD";
  WEB_COMPETITOR_HP_INPAGE_DESCRIPTION = "The place for all fixtures, results and #LIVESCORE_MAIN_KEYWORD for #COMPETITION_NAME";
  WEB_COMPETITION_HP_INPAGE_TITLE = "#COMPETITION_NAME #LIVESCORE_MAIN_KEYWORD";
  WEB_COMPETITION_HP_INPAGE_DESCRIPTION = "#LIVESCORE_MAIN_KEYWORD, fixtures and results for the #COMPETITION_NAME";
  WEB_COMPETITION_STANDINGS_INPAGE_TITLE = "#COMPETITION_NAME Standings #SEASON_YEAR";
  WEB_COMPETITION_6878_STANDINGS_INPAGE_TITLE = "#COMPETITION_NAME";
  WEB_SPORT_3_COMPETITION_STANDINGS_INPAGE_DESCRIPTION = "Stay updated with the live #COMPETITION_NAME to see the world's top tennis players.";
  WEB_COMPETITION_GROUPS_INPAGE_TITLE = "#COMPETITION_NAME Groups #SEASON_YEAR";
  WEB_COMPETITION_STANDINGS_INPAGE_DESCRIPTION = "Check out latest English #COMPETITION_NAME live Standings for #SEASON_YEAR";
  WEB_COMPETITION_GROUPS_INPAGE_DESCRIPTION = "Check out the #COMPETITION_NAME live updates";
  WEB_COMPETITOR_STANDINGS_INPAGE_TITLE = "#COMPETITOR_NAME Standings";
  WEB_COMPETITOR_GROUPS_INPAGE_TITLE = "#COMPETITOR_NAME Groups";
  WEB_COMPETITOR_STANDINGS_INPAGE_DESCRIPTION = "Check out the latest #COMPETITOR_NAME live standing for #SEASON_YEAR season";
  WEB_COMPETITOR_GROUPS_INPAGE_DESCRIPTION = "Check out the latest #COMPETITOR_NAME live groups for #SEASON_YEAR season";
  WEB_LEAGUE_CATALOG_INPAGE_TITLE = 'Competition Catalog';
  WEB_LEAGUES_CATALOG_DESCIPTION = 'The place to follow all competition for all sports around the world';
  WEB_FOLLOWING_PAGE_INPAGE_TITLE = 'Following teams and leagues';
  WEB_FOLLOWING_INPAGE_DESCRIPTION = 'Choose your favorite teams and leagues to get the most updated information';
  WEB_GAME_LINEUPS_INPAGE_TITLE = '#HOME_COMPETITOR #GAME_TITLE_VS  #AWAY_COMPETITOR: #LINEUPS';
  WEB_GAME_LINEUPS_INPAGE_DESCRIPTION = 'See the full lineup, with formation and transfers details';
  WEB_BOXSCORE_INPAGE_TITLE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR: #BOXSCORE';
  WEB_BOXSCORE_INPAGE_DESCRIPTION = 'See the full box score, transfers details and player statistics';
  WEB_GAME_STATS_INPAGE_TITLE = '#HOME_COMPETITOR #GAME_TITLE_VS  #AWAY_COMPETITOR: #STATS';
  WEB_GAME_STATS_INPAGE_DESCRIPTION = 'Go deep with all the match and team statistics from the match';
  WEB_H2H_INPAGE_TITLE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR: Head-to-Head';
  WEB_H2H_INPAGE_DESCRIPTION = 'Check out matchup head-to-head and see latest form';
  WEB_MATCHUP_INPAGE_TITLE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR';
  WEB_GAME_COMPETITION_DISPLAY_NAME_DESCRIPTION = '#COMPETITION_DISPLAY_NAME';
  WEB_COMPETITION_BRACKET_INPAGE_TITLE = '#COMPETITION_NAME #BRACKET_NAME';
  WEB_COMPETITION_BRACKET_INPAGE_DESCRIPTION = 'Follow #COMPETITION_NAME playoffs! Get all the #LIVESCORE_MAIN_KEYWORD here';
  WIDGET_GAMBLE_DISCLAIMER = "Gamble with responsibility";
  WEB_ENTITY_PREVIEW = "Preview";
  SEO_SD_ORGANIZATION_KNOWSABOUT = "Live Scores,Team Standings,League Standings,League Fixtures,Leagues";
  SEO_SD_ORGANIZATION_SAMEAS = "https://www.facebook.com/365scores,https://www.twitter.com/365scores,https://www.instagram.com/365scores,https://www.linkedin.com/company/365scores,https://www.crunchbase.com/organization/365scores";
  SEO_SD_ORGANIZATION_DESCRIPTION = "365Scores is a cross-platform application that enables users to create their own personalized sports channel";
  WEB_SPORT_1_COMPETITION_STATS_INPAGE_DESCRIPTION = "Statistics including top goal scorers, most assists and player performance statistics for the #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_2_COMPETITION_STATS_INPAGE_DESCRIPTION = "Season leaders including offensive and defensive player performance statistics for the #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_3_COMPETITION_STATS_INPAGE_DESCRIPTION = "Full statistics overview for #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_4_COMPETITION_STATS_INPAGE_DESCRIPTION = "Statistics including top skating and goaltending leaders for the #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_6_COMPETITION_STATS_INPAGE_DESCRIPTION = "Full statistics overview for #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_7_COMPETITION_STATS_INPAGE_DESCRIPTION = "Full statistics overview for #COMPETITION_NAME #SEASON_YEAR";
  WEB_SPORT_1_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Statistics for all #COMPETITOR_NAME's leagues & cups including top scorers; most assists and player performance statistics";
  WEB_SPORT_2_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Season leaders including offensive; defensive and player performance statistics for #COMPETITOR_NAME";
  WEB_SPORT_3_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Full statistics overview for all #COMPETITOR_NAME's leagues & cups";
  WEB_SPORT_4_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Full statistics overview for all #COMPETITOR_NAME's leagues & cups";
  WEB_SPORT_6_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Full statistics overview for all #COMPETITOR_NAME's leagues & cups";
  WEB_SPORT_7_COMPETITOR_STATS_INPAGE_DESCRIPTION = "Full statistics overview for all #COMPETITOR_NAME's leagues & cups";
  LINEUPS_EMPTY = "No lineups info available at the moment";
  WEB_COMPETITION_TRENDS_EMPTY_STATE = "No insights to display at the moment";
  WEB_GAME_CENTER_GAME_NUM = "Game #NUM";
  COUNTDOWN_DAYS = "Days";
  COUNTDOWN_HOURS = "Hours";
  COUNTDOWN_MINUTES = "Minutes";
  COUNTDOWN_SECONDS = "Seconds";

  //TODO: should be removed after api support
  SPORT_FOOTBALL = "Football";
  SPORT_BASKETBALL = "Basketball";
  SPORT_TENNIS = "Tennis";
  SPORT_HOCKEY = "Hockey";
  SPORT_HANDBALL = "Handball";
  SPORT_AMERICAN_FOOTBALL = "A.Football";
  SPORT_BASEBALL = "Baseball";
  SPORT_VOLLEYBALL = "Volleyball";
  SPORT_RUGBY = "Rugby";
  WEB_LIVE_SEPARATOR = "Live";

  //titles
  HOMEPAGE_TITLE_TEMPLATE = '365Scores - #LIVESCORE_MAIN_KEYWORD, Results, Fixtures, News and Stats';
  COMPETITION_HOME_TERM_IN_TITLE = 'Live Scores, Fixtures and Table';
  COMPETITION_STANDINGS_TERM_IN_TITLE = 'Table & Standings';
  COMPETITION_STANDINGS_TITLE_TEMPLATE = '#COMPETITION_NAME - #COMPETITION_STANDINGS_TERM_IN_TITLE - 365Scores';
  COMPETITION_GROUPS_TERM_IN_TITLE = 'Group Fixtures & Tables';
  COMPETITION_GROUPS_TITLE_TEMPLATE = '#COMPETITION_NAME - #COMPETITION_GROUPS_TERM_IN_TITLE - 365Scores';
  COMPETITION_BRACKET_TITLE_TEMPLATE = '#COMPETITION_NAME #BRACKET_NAME and Scores - #SPORT_TYPE - 365scores';
  COMPETITOR_HOME_TERM_IN_TITLE = '#LIVESCORE_MAIN_KEYWORD and Standings';
  COMPETITOR_HOME_TITLE_TEMPLATE = '#COMPETITOR_NAME #COMPETITOR_HOME_TERM_IN_TITLE - #SPORT_TYPE -365Scores';
  PLAYER_PROFILE_TITLE = 'Player Profile';
  MAIN_GAME_TERM_IN_TITLE_PRE = '#LIVESCORE_MAIN_KEYWORD & Stats';
  MAIN_GAME_TERM_IN_TITLE_POST = 'Match Report';
  GAME_LINEUPS_TERM_IN_TITLE = 'Match Lineups';
  GAME_BOX_SCORES_TITLE = 'Get the full Box Score - All personal statistics';
  GAME_STATS_TERM_IN_TITLE = 'Match Stats';
  GAME_STATS_TITLE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #GAME_STATS_TERM_IN_TITLE #DATE - 365Scores'
  GAME_H2H_TERM_IN_TITLE = 'Head To Head';
  ABOUT_TERM_IN_TITLE = 'About us';
  ADVERTISE_TERM_IN_TITLE = 'Advertise With Us';
  CONTACT_TERM_IN_TITLE = 'Contact us';
  JOBS_TERM_IN_TITLE = 'Jobs';
  PRIVACY_TERM_IN_TITLE = 'Privacy Policy';
  YESTERDAY_FOOTBALL_TITLE = 'Yesterday\'s Fooball Scores & Results';
  TOMORROW_FOOTBALL_TITLE = 'Tomorrow\'s Footabll Fixtures';
  HP_SCORES_DATE_TERM_IN_TITLE = '365Scores - Live Sports Scores - #DATE';
  COMPETITOR_RESULTS_TERM_IN_TITLE = 'Results';
  COMPETITOR_RESULTS_TITLE_TEMPLATE = '#COMPETITOR_NAME #COMPETITOR_RESULTS_TERM_IN_TITLE - #SPORT_TYPE - 365scores';
  COMPETITOR_FIXTURES_TERM_IN_TITLE = 'Fixtures';
  COMPETITOR_FIXTURES_TITLE_TEMPLATE = '#COMPETITOR_NAME #COMPETITOR_FIXTURES_TERM_IN_TITLE - #SPORT_TYPE - 365scores';
  COMPETITION_RESULTS_TERM_IN_TITLE = 'Results';
  COMPETITION_FIXTURES_TERM_IN_TITLE = 'Fixtures';
  MY_SCORES_PAGE_TITLE_TEMPLATE = 'My Scores - Your personalized Scores & Fixtures - 365Scores';
  FOOTBALL_HOME_TITLE = '365Scores - Live Football Scores, Results, Fixtures, News and Stats';
  LIVE_SCORES_TERM_IN_TITLE = '#LIVESCORE_MAIN_KEYWORD - Ongoing Matches and Results';
  LIVE_SCORES_DESCRIPTION_TEMPLATE = 'Get #LIVESCORE_MAIN_KEYWORD updates in real time for ongoing #SPORT_TYPE matches';
  SPORT_TYPE_HOME_TITLE_TEMPLATE = '#SPORT_TYPE #LIVESCORE_MAIN_KEYWORD , Fixtures and Standings - 365Scores';
  SPORT_TYPE_HOME_DESCRIPTION_TEMPLATE = '365Scores offers online #LIVESCORE_MAIN_KEYWORD updates. Our #SPORT_TYPE coverage includes fixtures, standings, stats and odds for over 1,000 competitions worldwide'
  WEB_ALL_SCORES_SHOW_ALL_BUTTON = 'See all matches';
  MY_SELECTIONS_COMPETITORS = "My Teams";
  MY_SELECTIONS_COMPETITIONS = "My Leagues";
  WEB_MY_SELECTIONS_EMPTY_STATE_COMPETITIONS_AND_TEAMS = "Select Teams and Competitions to follow them here";
  WEB_FOLLOWING_PAGE_TEAMS_EMPTY_STATE = 'Select your favorite teams to follow them here';
  WEB_FOLLOWING_PAGE_COMPETITIONS_EMPTY_STATE = 'Select your favorite leagues to follow them here';
  WEB_WIZARD_DONE = 'Done';
  SEARCH_INSTRUCTIVE_TEXT = 'Search for teams and leagues';
  SEARCH_INSTRUCTIVE_TEXT_NEW = "League, team or player";
  SEARCH_INSTRUCTIVE_TEXT_NEW_DESKTOP = "League, team or player";
  SEARCH_INSTRUCTIVE_TEXT_NEW_MOBILE = "Search here...";
  LIVE_MATCHES_EMPTY_STATE = "It doesn't happen often, but there are no live matches being played right now. Check it out later";
  WEB_NO_CONTENT_GAMES = "No games on this day";
  WEB_WATCH_STREAMING_AB_TESTING_GROUP_A = "0.5";
  WEB_WIZARD_AB_TESTING_DISABLED_GROUP = "0.1";
  WEB_NOTIFICATIONS_2ND_NOTICE_TEXT = "If you change your mind - click the Lock icon and allow browser notifications";
  WEB_NOTIFICATIONS_NOTICE_SESSION_GAP = '1';
  WEB_STANDINGS_PREVIEW_NUMBER_OF_COMPETITIONS_TO_SHOW = "5";
  FOLLOWING_PAGE_TITLE_TEMPLATE = "Following - Your favorite teams and leagues - 365Scores";
  FOLLOWING_PAGE_DESCRIPTION_TEMPLATE = "Choose your favorite teams and leagues to get the most updated information -  livescore, fixtures, statistics and more";
  COMPETITION_CATALOGUE_TITLE_TEMPLATE = "Competitions Catalogue - Competition List for All The Sports in the world";
  COMPETITION_CATALOGUE_DESCRIPTION_TEMPLATE = "Get the complete competition list for all sports around the world.  Follow your favorite leagues, teams, and sport type with our worldwide coverage";
  WEB_MY_SCORES_NEXT = "Next 7 Days";
  WEB_MY_SCORES_PREVIOUS = "Previous 7 Days";
  WEB_COMPETITOR_BRACKET_INPAGE_TITLE = "#COMPETITOR_NAME | #BRACKET_NAME";
  WEB_COMPETITOR_BRACKET_INPAGE_DESCRIPTION = "#COMPETITOR_NAME | #BRACKET_NAME | #LIVESCORE_MAIN_KEYWORD";
  WEB_COMPETITION_STATS_TERM_IN_TITLE = 'Player & Team Stats';
  WEB_COMPETITION_STATS_TITLE_TEMPLATE = '#COMPETITION_NAME: #WEB_COMPETITION_STATS_TERM_IN_TITLE - 365Scores';
  WEB_COMPETITION_STATS_DESCRIPTION = 'Get the complete detailed #COMPETITION_NAME #SEASON_YEAR top statistics and scores info with player and team stats overview.'
  WEB_COMPETITION_STATS_INPAGE_TITLE = '#COMPETITION_NAME: Live Statistics';
  WEB_COMPETITION_STATS_INPAGE_DESCRIPTION = 'Updated live statistics for the #COMPETITION_NAME #SEASON_YEAR';
  WEB_COMPETITOR_STATS_TERM_IN_TITLE = 'Leagues & Cups Stats';
  WEB_COMPETITOR_STATS_TITLE_TEMPLATE = '#COMPETITOR_NAME: WEB_COMPETITOR_STATS_TERM_IN_TITLE - 365Scores';
  WEB_COMPETITOR_STATS_DESCRIPTION = 'Get the complete detailed top statistics and scores info of all #COMPETITOR_NAME leagues and cups';
  WEB_COMPETITOR_STATS_INPAGE_TITLE = '#COMPETITOR_NAME: #STATS';
  WEB_COMPETITOR_STATS_INPAGE_DESCRIPTION = 'Updated live statistics for all #COMPETITOR_NAME competitions';
  WEB_GAME_OFFICIAL_HIGHLIGHT = 'Official Highlights';
  WEB_COMPETITION_INSIGHTS_INPAGE_DESCRIPTION = 'Get the latest #COMPETITION_NAME Insights including insights, trends, odds, predictions, and winning tips';
  WEB_COMPETITION_INSIGHTS_INPAGE_TITLE = '#COMPETITION_NAME Insights and Trends';
  WEB_COMPETITION_TRANSFERS_INPAGE_TITLE = '#COMPETITION_NAME: Transfers';
  WEB_COMPETITION_TRANSFERS_INPAGE_DESCRIPTION = 'COMPETITION_NAME Transfer News and Rumors: Breaking news, rumors, and information on all the latest transfers.';
  COMPETITION_INSIGHTS_DESCRIPTION_TEMPLATE = 'Stay Ahead of the Game with Free #COMPETITION_NAME Insights: Latest #SPORT_TYPE Trends, Odds, Predictions, and Winning Tips';
  COMPETITION_INSIGHTS_TITLE_TEMPLATE = '#COMPETITION_NAME Insights, Trends, Predictions & Tips - 365Scores';
  COMPETITION_TRANSFERS_TITLE_TEMPLATE = '#COMPETITION_NAME Transfer News and Rumors - 365Scores';
  COMPETITION_TRANSFERS_DESCRIPTION_TEMPLATE = 'Get the full review on #COMPETITION_NAME transfers news, rumors, new players and done deals including transfer fees.';
  COMPETITION_ODDS_MD_TITLE = '#COMPETITION_NAME: Betting Odds & Lines - 365Scores';
  COMPETITION_ODDS_MD_DESCRIPTION = 'Stay ahead in #COMPETITION_NAME with the finest #SPORT_TYPE live betting odds. Our comparison brings you top bookmaker rates and betting lines for informed decisions';
  WEB_COMPETITION_ODDS_INPAGE_TITLE = "#COMPETITION_NAME: Betting Odds & Lines";
  WEB_COMPETITION_ODDS_INPAGE_DESCRIPTION = "#COMPETITION_NAME best odds for top bookmakers including betting lines, markets, rates and more";

  //description
  COMPETITION_HOME_DESCRIPTION_TEMPLATE = 'Get the latest on #COMPETITION_NAME. #LIVESCORE_MAIN_KEYWORD, Match Centre, Fixtures & Results, Statistics, Standings, News, Videos and Highlights';
  COMPETITION_STANDINGS_DESCRIPTION_TEMPLATE = 'Follow live table & standings updates of the #COMPETITION_NAME on 365Scores';
  COMPETITION_GROUPS_DESCRIPTION_TEMPLATE = 'Follow live updates of #COMPETITION_NAME Group Tables & Standings on 365Scores';
  COMPETITOR_HOME_DESCRIPTION_TEMPLATE = 'Get the latest on #COMPETITION_NAME. #LIVESCORE_MAIN_KEYWORD, Match Centre, Fixtures & Results, Statistics, Standings, News, Videos and Highlights';
  COMPETITOR_STANDING_DESCRIPTION_TEMPLATE = 'Follow live table & standings updates of the  #COMPETITOR_NAME on 365Scores';
  COMPETITOR_BRACKET_DESCRIPTION = 'Get the complete #COMPETITOR_NAME Knockout Round #BRACKET_NAME in #COMPETITION_NAME. See also #LIVESCORE_MAIN_KEYWORD, team transfers and fixtures.';
  COMPETITOR_TRANSFERS_TITLE_TEMPLATE = '#COMPETITOR_NAME transfer news, signings and rumors - 365Scores';
  COMPETITOR_TRANSFERS_DESCRIPTION_TEMPLATE = 'Get the full review on #COMPETITOR_NAME transfers news, rumors, signing and done deals including transfer fees.';
  COMPETITION_BRACKET_DESCRIPTION = 'Get the complete #COMPETITION_NAME Knockout Rounds #BRACKET_NAME. See also #LIVESCORE_MAIN_KEYWORD, team squads and fixtures.';
  PLAYER_HOME_DESCRIPTION = 'Get the latest on #ATHLETE_NAME. News, statistics, videos and highlights';
  MAIN_GAME_PRE_DESCRIPTION_TEMPLATE = '#COMPETITION_NAME, #HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE), #STADIUM_NAME. Get the complete Match Preview on 365Scores';
  MAIN_GAME_POST_DESCRIPTION_TEMPLATE = '#COMPETITION_NAME, #HOME_COMPETITOR #HOME_SCORE - #AWAY_SCORE #AWAY_COMPETITOR (#DATE), #STADIUM_NAME. Get the complete Match Report';
  GAME_LINEUPS_DESCRIPTION_TEMPLATE = '#COMPETITION_NAME, #HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE), #STADIUM_NAME. Get all the match lineups info - Injuries, suspensions and the starting 11';
  GAME_BOXSCORE_DESCRIPTION_TEMPLATE = '#COMPETITION_NAME, #HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE), #STADIUM_NAME. Get the full Box Score - All personal statistics';
  GAME_STATS_DESCRIPTION_TEMPLATE = '#COMPETITION_NAME, #HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE), #STADIUM_NAME. Get the complete match statistics';
  GAME_H2H_DESCRIPTION_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE) - #COMPETITION_NAME. Get the complete Head to Head Record and teams recent form';
  ABOUT_DESCRIPTION_TEMPLATE = 'It\'s just the best sports scores service money can buy - And it\'s FREE!';
  ADVERTISE_DESCRIPTION_TEMPLATE = 'Check out our unique sponsorship and advertising opportunities';
  CONTACT_DESCRIPTION_TEMPLATE = 'We\'re always there for you, 365 days a year';
  JOBS_DESCRIPTION_TEMPLATE = 'Come work with the best people in the online sports industry';
  PRIVACY_DESCRIPTION_TEMPLATE = 'Keeping you privacy is a sacred principle for us';
  YESTERDAY_FOOTBALL_DESCRIPTION = 'Get all the football fixtures of tomorrow - Match list, lineups and stats';
  TOMORROW_FOOTBALL_DESCRIPTION = 'See complete results of all football matches played yesterday';
  PAGE_NOT_FOUND_DESCRIPTION = 'Page wasn\'t found, but we have some interesting suggestions for you';
  HP_SCORES_DATE_DESCRIPTION_TEMPLATE = 'Get all the #SPORT_TYPE scores for #DATE - Our coverage includes fixtures & results, teams and league tables, match live stats, odds and event timeline for over 1,000 competitions worldwide';
  COMPETITOR_RESULTS_DESCRIPTION_TEMPLATE = 'Get the complete result list of #COMPETITOR_NAME. See also Live Scores, team transfers, statistics, table, news, and videos';
  COMPETITOR_FIXTURES_DESCRIPTION_TEMPLATE = 'Get the complete fixture list of #COMPETITOR_NAME. See also Live Scores, team transfers, statistics, table, news, and videos';
  COMPETITION_RESULTS_DESCRIPTION_TEMPLATE = 'Get the complete result list of #COMPETITION_NAME. See also Live Scores, team transfers, statistics, table, news, and videos';
  COMPETITION_FIXTURES_DESCRIPTION_TEMPLATE = 'Get the complete fixture list of #COMPETITION_NAME. See also Live Scores, team transfers, statistics, table, news, and videos';
  MY_SCORES_PAGE_DESCRIPTION_TEMPLATE = 'Personalise your experiance - Follow Matches, Teams and Leagues that interest YOU. Get the most relevant Results, #LIVESCORE_MAIN_KEYWORD and Fixture in one place.';
  HOMEPAGE_DESCRIPTION_TEMPLATE = '365Scores offers online live sports scores updates. Our football coverage includes fixtures, standings, stats and odds for over 1,000 competitions worldwide.';
  TERMS_OF_USE_DESCRIPTION = "Terms and Conditions";
  LIVESCORE_MAIN_KEYWORD = 'Livescore';
  LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD = 'Livescore';
  WEB_COMPETITOR_SQUAD_INPAGE_TITLE = "#COMPETITOR_NAME: #SQUAD";
  WEB_COMPETITOR_SQUAD_INPAGE_DESCRIPTION_GENERAL = "#COMPETITOR_NAME transfers for the #SEASON_YEAR_LONG season including #STIRKERS, #MIDFIELDERS, #DEFENDERS, and more";
  WEB_COMPETITOR_SQUAD_INPAGE_DESCRIPTION_SPORTID1 = "#COMPETITOR_NAME transfers for the #SEASON_YEAR_LONG season including #STIRKERS, #MIDFIELDERS, #DEFENDERS, and more";
  WEB_COMPETITOR_SQUAD_INPAGE_DESCRIPTION_SPORTID2 = "#COMPETITOR_NAME transfers for the #SEASON_YEAR_LONG season including #GUARDS, #FORWARDS, #CENTERS and more";
  WEB_COMPETITOR_SQUAD_INPAGE_DESCRIPTION_SPORTID4 = "#COMPETITOR_NAME transfers for the #SEASON_YEAR_LONG season including #FORWARDS, #DEFENSEMAN and #GOALIE";
  WEB_COMPETITOR_SQUAD_INPAGE_DESCRIPTION_SPORTID6 = "#COMPETITOR_NAME transfers for the #SEASON_YEAR_LONG season including #OFFENSE, #DEFENSIVE and #SPECIALTEAM";
  WEB_SEO_SEASON_YEAR_LONG = "2021/2022";
  WEB_SEO_SEASON_YEAR_SHORT = "21/22";
  WEB_SQUAD_POSITION_SECTION_GOALKEEPERS = "Goalkeepers";
  WEB_SQUAD_POSITION_SECTION_DEFENDERS = "Defenders";
  WEB_SQUAD_POSITION_SECTION_MIDFIELDERS = "Midfielders";
  WEB_SQUAD_POSITION_SECTION_STRIKERS = "Strikes";
  WEB_SQUAD_POSITION_SECTION_GUARDS = "Guards";
  WEB_SQUAD_POSITION_SECTION_FORWARD = "Forwards";
  WEB_SQUAD_POSITION_SECTION_CENTERS = "Centers";
  WEB_SQUAD_POSITION_SECTION_DEFENSIVE = "Defense";
  WEB_SQUAD_POSITION_SECTION_OFFENSE = "Offense";
  WEB_SQUAD_POSITION_SECTION_SPECIAL_TEAM = "Special team";
  WEB_SQUAD_POSITION_SECTION_DEFENSEMAN = "Defenseman";
  WEB_SQUAD_POSITION_SECTION_GOALIE = "Goalie";
  WEB_SQUAD_POSITION_SECTION_MANAGEMENT = "Management";
  WEB_COMPETITOR_SQUAD_TERM_IN_TITLE = "Squad & Players #SEASON_YEAR_SHORT";
  WEB_COMPETITOR_SQUAD_TITLE_TEMPLATE = "#COMPETITOR_NAME: #WEB_COMPETITOR_SQUAD_TERM_IN_TITLE - 365Scores";
  WEB_COMPETITOR_SQAUD_DESCRIPTION_TEMPLATE = "Get the complete detailed transfers and player information for #COMPETITOR_NAME #SEASON_YEAR_SHORT. See player position, jersey numbers and more";
  WEB_COMPETITOR_TRANSFERS_INPAGE_TITLE = '#COMPETITOR_NAME: Transfers';
  WEB_COMPETITOR_TRANSFERS_INPAGE_DESCRIPTION = 'Transfer market news for #COMPETITOR_NAME including latest news, rumors, signings and departures.';
  MD_TITLE_BOLAO_HOMEPAGE = "365Scores - World Cup #bolaoName";
  MD_DESCRIPTION_BOLAO_HOMEPAGE = "365Scores offers a free social guessing game for Fifa World Cup 2022! Create your own group, invite friends to join and bit them with your predictions."
  TERMS_OF_USE_TITLE_TEMPLATE = "Terms of Use - 365cores";
  ABOUT_TITLE_TEMPLATE = '#ABOUT_TERM_IN_TITLE - 365scores';
  ADVERTISE_TITLE_TEMPLATE = '#ADVERTISE_TERM_IN_TITLE - 365scores';
  JOBS_TITLE_TEMPLATE = '#JOBS_TERM_IN_TITLE - 365scores';
  CONTACT_TITLE_TEMPLATE = '#CONTACT_TERM_IN_TITLE - 365scores';
  PRIVACY_TITLE_TEMPLATE = '#PRIVACY_TERM_IN_TITLE - 365scores';
  COMPETITION_HOME_TITLE_TEMPLATE = 'Get the latest on #COMPETITION_NAME. #LIVESCORE_MAIN_KEYWORD, Match Centre, Fixtures & Results, Statistics, Standings, News, Videos and Highlights';
  COMPETITOR_STANDINGS_TITLE_TEMPLATE = '#COMPETITOR_NAME #TABLE_AND_STANDINGS - #SPORT_TYPE - 365Scores';
  COMPETITOR_BRACKET_TITLE_TEMPLATE = '#COMPETITOR_NAME #BRACKET_NAME and Scores - #COMPETITION_NAME - 365scores';
  GC_VS = 'v';
  HP_SCORES_DATE_TITLE_TEMPLATE = 'Live Sports Scores - #DATE - 365Scores';
  HP_SCORES_DATE_TITLE = 'Sports #LIVESCORE_MAIN_KEYWORD';
  MAIN_GAME_TITLE_PRE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #MAIN_GAME_TERM_IN_TITLE_PRE - 365Scores';
  MAIN_GAME_TITLE_POST_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #MAIN_GAME_TERM_IN_TITLE_POST - 365Scores';
  GAME_LINEUPS_TITLE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #GAME_LINEUPS_TERM_IN_TITLE #DATE - 365Scores';
  GAME_H2H_TITLE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #H2H_TERM_IN_TITLE #DATE - 365Scores';
  COMPETITION_FIXTURES_TITLE_TEMPLATE = '#COMPETITION_NAME #COMPETITION_FIXTURES_TERM_IN_TITLE - #SPORT_TYPE - 365Scores';
  COMPETITION_RESULTS_TITLE_TEMPLATE = '#COMPETITION_NAME #COMPETITION_RESULTS_TERM_IN_TITLE - #SPORT_TYPE - 365Scores';
  LIVE_SCORES_TITLE_TEMPLATE = '#LIVE_SCORES_TERM_IN_TITLE - 365Scores';
  GAME_BOXSCORE_TITLE_TEMPLATE = '#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR - #GAME_BOXSCORE_TERM_IN_TITLE #DATE - 365Scores';
  GAME_BOXSCORE_TERM_IN_TITLE = 'Box Score';
  WC_2022_TOURNAMENT_NAME = 'World Cup';
  PROMOTED_FOOTER_COMPETITION_NAME = 'Brasileirão Série A';
  SEO_TO_FOOTER_UEFA_CHAMPIONS_LEAGUE_NAME = 'Champions League';
  SEO_TO_FOOTER_LINK_WOMENS_WORLD_CUP_COMPETITION_NAME = 'Women\'s World Cup';
  WC_2022_BOLAO_NAME = 'Office Pool';
  WC_2022_KICKOFF = 'Kick Off';
  WC_2022_COUNTDOWN_DAYS = 'Days';
  WC_2022_COUNTDOWN_HOURS = 'Hours';
  WC_2022_COUNTDOWN_MINUTES = 'Minutes';
  WC_2022_NAVIGATION_BAR_BUTTON = "Prediction Cup 2022";
  WC_2022_FOOTER_COMPETITION_NAME = "World Cup";
  ATHLETE_LAST_MATCHES = 'Last Matches';
  TRANSFERS = 'Transfers';
  ATHLETE_COMPETITOR_MORE_PLAYERS_SEPARATOR = 'More #COMPETITOR_NAME players';
  ATHLETE_TROPHIES_TITLE = 'Trophies';
  WEB_ATHLETE_DESCRIPTION = 'Get all the information about #ATHLETE_NAME including player profile, stats, transfer history, trophies, achievements and more';
  WEB_ATHLETE_TITLE_TEMPLATE = '#ATHLETE_NAME (#COMPETITOR_NAME) - #WEB_ATHLETE_TERM_IN_TITLE - 365Scores';
  WEB_ATHLETE_TERM_IN_TITLE = 'Bio, stats and news';
  WEB_ATHLETE_FREE_AGENT = 'Free Agent';
  WEB_ATHLETE_CAREER_HISTORY_SEPARATOR = 'Transfer History';
  WEB_SEARCH_MOST_POPULAR_ATHLETES = "Most popular athletes";
  WEB_OOPS = "OOPS!";
  WEB_PAGES_SOFT_404_STATEMENT = "Looks like the page you were searching for has been lost in the stands";
  WEB_PAGES_SOFT_404_CTA = "See All Scores";
  PAGE_NOT_FOUND_TITLE_TEMPLATE = "#404_PAGE_NOT_FOUND_TERM_IN_TITLE - 365scores";
  PAGE_NOT_FOUND_TERM_IN_TITLE = "404 Page Not Found";
  PAGE_NOT_FOUND_DESCRIPTION_TEMPLATE = "Page wasn't found, but we have some interesting suggestions for you";
  WEB_STANDING_COMPETITION_RULES_CARD_HEADER = "Competition Rules";
  WEB_TRENDS_TITLE = "Trends";
  WEB_TRANSFERS_TAB = "Transfers";
  WEB_COMPETITION_TAB_INSIGHTS = "Trends";
  WEB_TRENDS_SLIDER_SEE_ALL_CARD = "View All Trends";
  WEB_TRENDS_SLIDER_CARD_TITLE = "Top trends";
  WEB_TEAM_OF_THE_WEEK_BEST_XI = "BEST XI";
  COMPETITION_STANDING_INFO_TEXT_ELEMENT_ID_113 = "TDB";
  WEB_PENALTY_SHOTS_CARD_HEADER_ATHLETE = "Penalty Shot Map";
  WEB_PENALTY_SHOTS_PENALTY_CONVERSION = "Penalty Goals";
  WEB_PENALTY_SHOTS_FAVORITE_GOAL_ZONE = "Preferred Goal Zone";
  WEB_PENALTY_SHOTS_MINUTE = "Minute";
  WEB_PENALTY_SHOTS_OUTCOME = "Outcome";
  WEB_SHOT_MAP_OUTCOME_XG = "xG";
  WEB_SHOT_MAP_OUTCOME_XGOT = "xGOT";
  WEB_PLAYER_POP_UP_HEATMAP = "Heat map"
  WEB_PLAYER_POP_UP_SHOTMAP = "Shot map";
  WEB_SHOT_MAP_OUTCOME_SITUATION = "Situation";
  WEB_SHOT_MAP_OUTCOME_BODY_PART = "Shot Type";
  WEB_SHOT_MAP_SHOW_LESS = "Show Less";
  WEB_SHOT_MAP_SHOW_MORE = "Show More";
  WEB_PENALTY_POPUP_LIVE = "Live";
  WEB_PENALTY_POPUP_TOP_PENALTY_KICKERS = "Top Penalty Kickers";
  WEB_PENALTY_POPUP_PENALTY_AWARDED = "Penalty Awarded";
  WEB_PENALTY_POPUP_CLOSE = "";
  WEB_PLAYER_POPUP_PLAYER_CARD = "";
  WEB_TREND_H2H_CARD = "H2H";
  WEB_LINEUPS_CONFIRMED_BADGE = "Confirmed";
  WEB_PREDICTABLE_LINEUPS_BADGE = "Predictable";

  PRE_GAME_CONSOLIDATE_DESCRIPTION_TEMPLATE = "#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR (#DATE) on #COMPETITION_NAME. Get match preview including live scores, lineups, stats, H2H and much more.";
  POST_GAME_CONSOLIDATE_DESCRIPTION_TEMPLATE = "#HOME_COMPETITOR #HOME_SCORE - #AWAY_SCORE #AWAY_COMPETITOR on #COMPETITION_NAME (#DATE). Get match report including live scores, lineups, stats, H2H and much more.";
  PRE_GAME_CONSOLIDATE_TITLE_TEMPLATE = "#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR: live scores, lineups & H2H";
  POST_GAME_CONSOLIDATE_TITLE_TEMPLATE = "#HOME_COMPETITOR #GAME_TITLE_VS #AWAY_COMPETITOR: Match report, statistics, lineups & H2H";
  WEB_CONFIDENCE_BETS_HEADER = "Confident Bets";
  WEB_CLAIM_NOW = "Claim";
  WEB_ODDS_BY = "Odds by #Bookmaker"
  ENTITY_PAGE_TAG_ADD_STANDINGS_HEADER = "Add the #ENTITY_NAME Standings widget to your website";
  ENTITY_PAGE_TAG_ADD_SCORES_HEADER = "Add the #ENTITY_NAME scores widget to your website";
  ENTITY_PAGE_TAG_MORE_OPTION_TEXT = "See more options by";
  ENTITY_PAGE_TAG_LINK_TO_WSSP = "<a href=\"https://sports-widgets.365scores.com/\" target=\"_blank\" rel=\"nofollow\">Creating Customized Widgets</a>";
  ENTITY_PAGE_TAG_CTA_BUTTON = "Generate HTML Tag";
  GENERATE_TAG_COPY_CTA_BUTTON = "Copy";
  ENTITY_PAGE_TAG_COPY_INDICATION = "Code Copied to Clipboard";
  GENERATE_TAG_VIA_PAGE_IMPLEMENTATION_GUIDE = "To implement the #ENTITY_NAME widget on your website, simply copy the HTML tag by clicking the 'Copy' icon next to it. Then, paste this tag into the HTML of your webpage at the desired location.";
  GENERATE_TAG_VIA_PAGE_TERMS_AND_CONDITION = "* By copying this code, you agree to our <a href=\"https://organic-form-8bc.notion.site/365-Scores-Ltd-Widget-Terms-of-Use-409b36f222c14d6caf3d75bf8f32d920\" target=\"_blank\" rel=\"nofollow\">terms and conditions</a>.";
  GENERATE_TAG_VIA_PAGE_HIDE_TAG_CTA = "Hide Tag";
  GENERATE_SCORES_TAG_VIA_ENTITY_COACHMARK_TITLE = "Add #ENTITY_NAME Scores Widget to Your Site"
  GENERATE_TAG_VIA_ENTITY_COACHMARK_DESCRIPTION = "Get the widget by clicking '#GENERATE_TAG.' Copy the HTML tag and place it in your website's code to embed the widget."
  GENERATE_STANDINGS_TAG_VIA_ENTITY_COACHMARK_TITLE = "Add Standings Widget to Your Site"
  WEB_ENTITY_MATCHES_TAB_NAME = "Matches";
  WEB_ENTITY_DETAILS_TAB_NAME = "Details";
  WEB_RECENT_FORM = "Recent Form";
  WEB_ODDS_BY_FALLBACK_TEXT = "Explore current bonuses and special offers!";
  WEB_CORRECT_SCORE_ALL = "All";
  WEB_CORRECT_SCORE_MAIN = "Main";
  WEB_CORRECT_SCORE_HOME = "Home";
  WEB_CORRECT_SCORE_AWAY = "Away";
  WEB_NEWS_TAB_NAME = "News";
  WEB_COMPETITION_NEWS_INPAGE_TITLE = "#COMPETITION_NAME: News";
  WEB_COMPETITION_NEWS_INPAGE_DESCRIPTION = "Latest news and live updates from #COMPETITION_NAME and everything that is happening in #SPORT_TYPE today";
  WEB_NEWS_EMPTY_STATE_TEXT = "No news to display at the moment"
  MEDALS_PREVIEW_TITLE = "Medals";
  NEWS_FEED_CARD_HEADER_TITLE = "Live #ENTITY_NAME News";
  WEB_RELATED_ENTITIES = "You May Be Interested In";
  COMPETITION_HISTORY_TAB = "History";
  COMPETITION_HISTORY_WINNERS_CARD_HEADER_TITLE = "#COMPETITION_NAME winners";
  COMPETITION_HISTORY_BREADCRUMBS = "History";
  META_TITLE_COMPETITION_HISTORY_WINNERS = "#COMPETITION_NAME: History Winners By Season - 365Scores";
  META_DESCRIPTION_COMPETITION_HISTORY_WINNERS = "Get a sneak peek at #COMPETITION_NAME's recent champions! Discover the previous seasons’ winners and their key stats, points, and goals.";
  COMPETITION_HISTORY_INPAGE_TITLE = "#COMPETITION_NAME: History Winners";
  COMPETITION_HISTORY_INPAGE_DESCRIPTION = "Checkout the #COMPETITION_NAME’s champions through the years with the previous seasons title holders."
  OLYMPICS_PARIS_2024_5_BUTTON = "Paris 2024";
  ON_TV_SPORT_TYPE_MENU_TAB = "TV";
  NO_BROADCASTING_MATCHES_DATE_EMPTY_STATE = "No games on this day";
  WEB_ON_TV_INPAGE_TITLE = "Live Sport On TV Today";
  WEB_ON_TV_INPAGE_DESCRIPTION = "Find today's live games and where to watch them in #COUNTRY.";
  ENTITY_DESCRIPTION_ON_TV_CROSS_SPORT_TYPE_MANDAROTY = "<h3>On TV: Your Ultimate Guide to Live Sports Today</h3>    <p>We understand the hassle of finding when and where your favorite sports events are being broadcast, especially when you're on the go. Our \"On TV\" page simplifies your search by providing a comprehensive TV schedule for all sports events, including <a href=\"https://www.365scores.com/football\">football</a>, <a href=\"https://www.365scores.com/basketball\">basketball</a>, and <a href=\"https://www.365scores.com/tennis\">tennis</a>, tailored to your location and time zone.</p>    <p>With \"On TV,\" you can effortlessly find sport on TV today in #COUNTRY, ensuring you never miss out on the action. Whether you're looking for live sport on TV, streaming options, or the latest sports on TV today, our platform has got you covered.</p>    <p>In addition to the main sports, we also cover a wide range of other sports such as <a href=\"https://www.365scores.com/baseball\">baseball</a>, <a href=\"https://www.365scores.com/hockey\">hockey</a>, <a href=\"https://www.365scores.com/a.-football\">American football</a>, and many other sport types. Our service automatically adjusts the times to match your local time zone and dynamically shows the relevant channels and broadcasters for each country. This way, you know exactly where and when to tune in without the hassle of searching multiple sources.</p>    <p>Say goodbye to the stress of missing out on your favorite games. With our reliable guide, you'll always know where's the match and can enjoy live sport on TV seamlessly. Designed for fans who value their time and love sports, our \"On TV\" page is your go-to resource for all sports broadcasting information.</p>    <p>Stay updated with sport on TV today in #COUNTRY, and let us enhance your sports-watching experience. Enjoy the convenience and never miss a moment of the excitement with our comprehensive daily TV schedule on <a href=\"https://www.365scores.com\">365Scores</a>.</p><br>";
  WEB_TODAY_ONTV_HEADER = "Today on TV";
  META_TITLE_CROSS_SPORT_TYPE_ON_TV = "Where To Watch? Live Sports on TV Today - 365Scores";
  META_DESCRIPTION_CROSS_SPORT_TYPE_ON_TV = "No default value";
  ENTITY_DESCRIPTION_ON_TV_CROSS_SPORT_TYPE_HEADER = "<h3>On TV: Your Ultimate Guide to Live Sports Today</h3>";
  META_TITLE_MATCH_POSTPONED_GAME = "#HOME_COMPETITOR vs #AWAY_COMPETITOR - #COMPETITION_NAME (Postponed)"
  META_DESCRIPTION_MATCH_POSTPONED_GAME = "Find out when the postponed #COMPETITION_NAME match between #HOME_COMPETITOR and #AWAY_COMPETITOR will be played next. Get the reschedule on 365Scores."
  META_TITLE_MATCH_CANCELLED_GAME = "#HOME_COMPETITOR vs #AWAY_COMPETITOR - #COMPETITION_NAME (Cancelled)"
  META_DESCRIPTION_MATCH_CANCELLED_GAME = "The #COMPETITION_NAME match between #HOME_COMPETITOR and #AWAY_COMPETITOR has been cancelled. Visit 365Scores to learn what's next."
  WEB_DYNAMIC_COACHMARK_TESTOSH = "Look it's working, good job Yael!";
  WEB_PBP_TAB = "Point By Point";
  WEB_POINT_BY_POINT = "Point By Point";
  WEB_CURRENT_GAME = "Current Game";
  WEB_HIGHLIGHTS_TAB = "Highlights";
  WEB_FILTER_ALL_COMPETITORS = "All Competitors";
  WEB_HIGHLIGHTS = "Latest Highlights";
  WEB_LATEST_HIGHLIGHTS = "Latest Highlights";
  WEB_DROP_ALL_TEAMS = "All Teams";
  WEB_DROP_ALL_HIGHLIGHTS = "All Highlights";
  WEB_HIGHLIGHTS_FULL_PAGE_HEADER = "Highlights";
  HIGHLIGHTS_NO_RESULTS_FOUND = "No results found.";
  NOTIFICATIONS_MESS_1 = "We will guide you through the steps to solve any notification issues on your device. Follow the instructions carefully to ensure you receive all the latest updates.";
  NOTIFICATIONS_POP_CONTINUE = "Continue";
  NOTIFICATIONS_POP_CLOSE = "Close";
  NOTIFICATIONS_POP_BACK = "Back";
  NOTIFICATIONS_FINISH_MESSAGE = "Great, Enjoy live notifications from now!";
  NOTIFICATIONS_POP_HEADER1 = "Check your system settings";
  NOTIFICATIONS_POP_IOS1 = "Open Settings → Notification and scroll down and select your browser";
  NOTIFICATIONS_POP_IOS2 = "Ensure 'Allow Notifications' is ON";
  NOTIFICATIONS_POP_ANDROID1 = "Open Settings → Apps & Notifications → Chrome (or your browser)";
  NOTIFICATIONS_POP_ANDROID2 = "Tap Notifications and turn them ON";
  NOTIFICATIONS_POP_PC1 = "Open Settings → System → Notifications & Actions and Ensure 'Get notifications from apps and other senders' is ON";
  NOTIFICATIONS_POP_PC_HEADER2 = "Enable Browser Notifications";
  NOTIFICATIONS_POP_PC2 = "Make sure your browser notifications setting is turned on";
  NOTIFICATIONS_POP_MAC1HEADER = "Check System Preferences";
  NOTIFICATIONS_POP_MAC1 = "Open System Settings → Notifications and Select your browser (Safari, Chrome, or Firefox) and enable 'Allow Notifications'";
  NOTIFICATIONS_FINISH_BUTTON = "Finish";
  NOTIFICATIONS_GUIDENCE_WEB = "Notifications guidance";
  META_TITLE_BETTING_HP = "Melhores Casas de Apostas no Brasil | Aposte com 365Scores";
  META_DESCRIPTION_BETTING_HP = "Descubra as melhores casas de apostas no Brasil com análises detalhadas, super odds, bônus exclusivos e tendências de apostas confiáveis. A 365Scores oferece insights especializados, comparações de odds em tempo real e guias completos para apostar com inteligência. Aposte fácil, aposte informado, aposte para ganhar!";
  READ_MORE = " Read More";
  READ_LESS = " Read Less";
  BETTING_CONVERTER_FRACTION = "Fraction";
  BETTING_CONVERTER_FRACTION_TOOLTIP = "Represents profit relative to stake (e.g., 5/1 means win 5 for every 1 bet).";
  BETTING_CONVERTER_DECIMAL = "Decimal";
  BETTING_CONVERTER_DECIMAL_TOOLTIP = "Total return for every 1 unit bet, including your stake."
  BETTING_CONVERTER_AMERICAN = "American"
  BETTING_CONVERTER_AMERICAN_TOOLTIP = "Shows profit on a $100 bet (+) or amount needed to win $100 (–)."
  BETTING_CONVERTER_PROBABILITY = "Impelled probability"
  BETTING_CONVERTER_PROBABILITY_TOOLTIP = "The chance of winning based on the odds (lower odds = higher chance)."
  BETTING_CALCULATOR_STAKE_HEADER = "Stake (Aposta)";
  BETTING_CALCULATOR_STAKE_DESCRIPTION = "Enter your bet amount for calculation";
  BETTING_CALCULATOR_RATE_HEADER = "Payout";
  BETTING_CALCULATOR_RATE_DESCRIPTION = "Choose your preferred odds format.";
  BETTING_CALCULATOR_PAYOUT_HEADER = "Rate";
  BETTING_CALCULATOR_PAYOUT_DESCRIPTION = "See your potential winnings based on stake and odds";
  BETTING_CALCULATOR_PROFIT = "Profit";
  BETTING_CALCULATOR_BUTTON = "Reset";
  BETTING_ARBITRAGE_QUANTITY_HEADER = "Bet place quantity";
  BETTING_ARBITRAGE_QUANTITY_DESCRIPTION = "How many bets will you place?";
  BETTING_ARBITRAGE_AMOUNT_HEADER = "Estimate total stake";
  BETTING_ARBITRAGE_AMOUNT_DESCRIPTION = "Enter your bet amount for calculation";
  BETTING_ARBITRAGE_STAKE = "Stake";
  BETTING_ARBITRAGE_PAYOUT = "Payout";
  BETTING_ARBITRAGE_PROFIT = "Profit";
  BETTING_ARBITRAGE_TOTAL = "True Total Stake";
  BETTING_ARBITRAGE_PROBABILITY = "Probability";
  BETTING_ARBITRAGE_MARGIN = "Profit Margin";
  BETTING_ARBITRAGE_RATE_1 = "Bet 1 Rate";
  BETTING_ARBITRAGE_RATE_2 = "Bet 2 Rate";
  BETTING_ARBITRAGE_RATE_3 = "Bet 3 Rate";
  BETTING_WIDGET_TODAY = "Today";
  BETTING_WIDGET_TOMORROW = "Tomorrow";
  BETTING_CALCULATOR_BET = "Bet on";
  BETTING_CALCULATOR_WIN = "To win:";
  EMPTY_STATE_TODAYS_PREDICTIONS = "There are no predictions for this day"
  WEB_SHARE_BUTTON = "Share";
  WEB_COPY_LINK_BUTTON = "Copy Link";
  BEST_ODDS_DROPDOWN_TOP_COMP = "Top Competitions";
  ODDS_BY_OFFERS_SECTION_CTA_TEXT = "See All Bookies Promotion";
  ODDS_BY_RATING_MAIN_TEXT = "Want to see how this bookmaker earned this rating?";
  ODDS_BY_RATING_CTA_TEXT = "Explore Full Bookie Breakdown";
  ODDS_BY_PC_SUB_HEADER = "Main “Bookie name” Pros & Cons"
  BZ_UNREGULATED_BOOKIE_BADGE = "Unregulated";
  BZ_UNREGULATED_BOOKIE_MESSAGE = "Unfortunately, Codere.MX bookmaker is not licensed in Brazil";
  WEB_KO_ODDS_HOVER = "Kickoff Odds";
  BETTING_ZONE_PROMO = "Code:";
  BETTING_ZONE_COPIED = "Copied!";
  WEB_FOOTER_BETTING_DISCLOSURE = "365scores.com partners with licensed betting operators in Brazil. When you sign up through our links, we may earn a commission—at no extra cost to you. This supports our free sports content, but never influences our honest recommendations. We only feature platforms we've independently evaluated for security, quality, and reliability. Your trust is our priority.";
  BZ_FOOTER_AFF_DISCLOSURE = "Affiliate Disclosure";
  BZ_FOOTER_GAMBLE_RESPONSIABLE = "Gamble responsibly";
  SETTINGS_TITLE = "Settings";
  NATIONALITY_BUTTON = "Nationality";
  CLUB_BUTTON = "Club";
  WEB_GAME_CENTER_BOOKED_GAME_TIME = "Booked";
  WEB_GAME_CENTER_AND_NOTIFICATION_MISSES_NEXT_MATCH = "Will miss next match";
  WEB_HEADER_GAME_CENTER_PLAYERS_AT_RISK_OF_SUSPENSION = "Players at risk of suspension";
  WEB_PLAYER_CARD_AT_RISK_ONE_YELLOW_FROM_SUSPENSION = "Suspension danger (One yellow card from suspension)";

  WEB_BOOKIE_COMPLIANCE = "Play responsibly. The Ministry of Finance warns: Betting is not an investment.";
  WEB_BOOKIE_LICENSE_161 = "License number: SPA/MF nº 2.090/2024";
  WEB_BOOKIE_LICENSE_14 = "License number: SPA/MF nº 250/2025";
  WEB_BOOKIE_LICENSE_139 = "License number: SPA/MF nº 247/2025";
  WEB_BOOKIE_LICENSE_156 = "License number: SPA/MF nº 249/2025";
}
